// extracted by mini-css-extract-plugin
export default {"button":"ErBb7","buttonContainer":"QeCAk","loaderContainer":"NHB-r"};